import { Store } from '@ngxs/store';
import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
//----------------------------------------------
import { ClearSearchDinersResult } from '../../store/diners/diners.action';
import { CancelTicket } from '../../store/tickets/tickets.action';
import {
  SelectResidentForGuestBillingModal,
  SelectResidentForGuestBillingModalProps
} from '../select-resident-for-guest-billing/select-resident-for-guest-billing.modal';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { TicketsStateSelectors } from 'src/app/store/tickets/tickets.selectors';
import { ModalService } from 'src/app/services';

export interface ChargeGuestMealModalProps {
  isLoading: boolean;
  cancelTicketOnClose: boolean;
}

@Component({
  selector: 'pos-charge-guest-meal-modal',
  templateUrl: './charge-guest-meal.modal.html',
  styleUrls: ['./charge-guest-meal.modal.scss']
})
export class ChargeGuestMealModal {
  @Input() isLoading = true;
  @Input() cancelTicketOnClose = true;

  @SelectSnapshot(TicketsStateSelectors.selectedTicketId)
  private readonly selectedTicketId: string;

  constructor(
    private readonly modalController: ModalController,
    private readonly store: Store,
    private readonly modalService: ModalService
  ) {}

  onCloseModal(noAssignmentDone: boolean = false, isMealPlanApplied = true) {
    this.clearSearchDinersAndUpdateTicket(
      noAssignmentDone,
      isMealPlanApplied
    ).then();
    this.modalController.dismiss();
  }

  async clearSearchDinersAndUpdateTicket(
    noAssignmentDone = false,
    isMealPlanApplied = true
  ) {
    const actions = [new ClearSearchDinersResult()];
    if (this.cancelTicketOnClose && noAssignmentDone) {
      actions.push(new CancelTicket(this.selectedTicketId));
    } else {
      if (isMealPlanApplied) {
        await this.showChargeGuestToAResidentMealPlanModal();
      }
      this.store.dispatch(actions);
    }
  }

  private async showChargeGuestToAResidentMealPlanModal() {
    const selectResidentForGuestBilling = await this.modalService.showModal<
      void,
      SelectResidentForGuestBillingModalProps
    >(SelectResidentForGuestBillingModal, {
      residentsOnly: true,
      cancelTicketOnClose: this.cancelTicketOnClose
    });
    await selectResidentForGuestBilling.present();
  }
}
